/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

// import 'babel-polyfill';
// import 'es6-promise/auto';

import Vue from "vue";
window.Vue = Vue;

// import store from "./store";
// import router from './router';
import AppWrapper from "./components/AppWrapper";

import VueVisible from "vue-visible";
Vue.use(VueVisible);

Vue.config.productionTip = false;

// import { sync } from 'vuex-router-sync'
// sync(store, router);

/* eslint-disable no-new */

import {
  Icon
} from 'leaflet'
import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;


import vuelidate from "vuelidate";
import vuelidateErrorExtractor, {
  templates
} from "vuelidate-error-extractor";
import customFormGroup from "./components/FormGroup.vue";

Vue.use(vuelidate);
Vue.use(vuelidateErrorExtractor, {
  template: customFormGroup,

  messages: {
    required: "Dieses Feld ist ein Pflichtfeld",
    email: "Bitte eine gültige E-Mail Adresse eintragen",
    slug: "Erlaubt sind in diesem Feld lediglich Kleinbuchstaben und Ziffern !",
    minLength: "Text zu kurz",
    maxLength: "Text zu lang"
  }
  // attributes: {
  //   email: "Email",
  //   first_name: "First name",
  //   last_name: "Last name"
  // }
});



Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

window.nfeventsApp = new Vue({
  el: "#nfjugendapp",
  // router,
  template: "<AppWrapper/>",
  components: {
    AppWrapper
  }
});
